import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-tabList" }
const _hoisted_2 = ["onClick", "onKeydown"]
const _hoisted_3 = {
  key: 0,
  class: "a-badgeCount"
}
const _hoisted_4 = { class: "a-tabHead__filters" }
const _hoisted_5 = { class: "m-tabMain" }
const _hoisted_6 = ["data-qa"]
const _hoisted_7 = { class: "a-tabPanelFooter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.modifier, "o-tabs"])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(['a-tabHead', {
                        'a-tabHead--active': _ctx.activeTab === tab.name,
                        '-selected': _ctx.selected
                    }]),
          key: tab.name,
          onClick: ($event: any) => (_ctx.switchTab(tab.name)),
          onKeydown: ($event: any) => (_ctx.handleKeyPress($event, tab.name)),
          tabindex: "0"
        }, [
          (tab.badgeValue && _ctx.activeTab !== tab.name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(tab.badgeValue), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, _ctx.tabHeadSlotName(tab.name), {}, () => [
            _withDirectives(_createElementVNode("span", null, null, 512), [
              [_directive_translate, {key: tab.translationObject?.key}]
            ])
          ])
        ], 42, _hoisted_2))
      }), 128)),
      _createElementVNode("li", _hoisted_4, [
        _renderSlot(_ctx.$slots, _ctx.modifier)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "a-tabPanel",
        "data-qa": _ctx.SearchQASelectors.TAB_PANEL
      }, [
        _renderSlot(_ctx.$slots, _ctx.tabPanelSlotName)
      ], 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.showBackButton)
          ? _renderSlot(_ctx.$slots, _ctx.tabPanelBtnSlotName, { key: 0 }, () => [
              _createElementVNode("button", {
                type: "button",
                class: "a-btnCta -action",
                "aria-label": "Confirm",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
              }, [
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Confirm}]
                ])
              ])
            ])
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}